<template>
  <div>
    <div class="m-b-2 m-t-1">
      <div class="layout gap-3">
        <div class="layout-item is-12 d-flex">
          <div class="d-flex fd-column ai-center">
            <!-- average stats box -->
            <div class="bd-gray70" selenium="average-rating">
              <div class="AVERAGE-RATING">
                {{ aggregation.average_rating | toFixed(1) }}
              </div>
              <div class="OUT">
                out of 5
              </div>
            </div>

            <!-- average stats stars -->
            <div class="STARS">
              <rating-stars :value="averageRating"/>
            </div>
          </div>

          <div class="flex-1-1 m-l-2 m-l-4:t" selenium="ratings-graph">
            <!-- bar chart -->
            <div
                v-for="rating in reviewRatingDistributionKeys"
                @click="filterReview(rating)"
                :key="rating"
                class="c-gray70 CURSOR">
              <percentage-bar :value="aggregateRating(rating)" >
                <span slot="pre" class="PRE" :selenium="`${rating}-stars-rating`">
                  {{ rating | toFixed(0) }} star
                </span>
                <span slot="post" class="POST">
                  {{ aggregation.rating_count[rating] }}
                </span>
              </percentage-bar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PercentageBar from '@/components/PercentageBar';

export default {
  name: 'reviews-header',
  components: {
    PercentageBar,
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    from: {
      type: Number,
      required: true,
    },
    aggregation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reviewRatingDistributionKeys () {
      // These are the 1-5 total rating counts sorted desc
      return Object.keys(this.aggregation.rating_count).sort().reverse();
    },
    averageRating () {
      return this.aggregation.average_rating === 'NaN' ? 0 : this.aggregation.average_rating;
    },
  },
  methods: {
    filterReview (rating) {
      if (this.aggregateRating(rating)) {
        this.$emit('percentage-bar', rating);
      }
    },
    aggregateRating (rating) {
      return this.aggregation.rating_count[rating] / (this.total || 1);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .AVERAGE-RATING {
    @include h5;
    padding: $unit 2*$unit;
    color: $color-depot;
    font-weight: 700;
    text-align: center;

    @include tablet {
      @include h1;
    }
  }

  .OUT {
    @include text-medium;
    padding: $unit 2*$unit;
    color: white;
    background-color: $color-gray70;
    text-align: center;

    @include tablet {
      @include text-large;
    }
  }

  .STARS {
    @include text-medium;
    margin: $unit 0;

    @include tablet {
      font-size: inherit;
    }
  }

  .PRE {
    @include text-medium;
    @include margin-right(0.5, 1);
  }

  .POST {
    @include text-medium;
    @include margin-left(0.5, 1);
    display: flex;
    min-width: 4*$unit;
  }

  .CURSOR {
    cursor: pointer;
  }
</style>
